export default __webpack_public_path__ + "static/media/DEG.12502de9.png";